/**
 * Applications base state store
 */
import { assign } from 'lodash';
import moment from 'moment';
import { languageService } from '../services/LanguageService';
const EventEmitter = require('events').EventEmitter;
var DEFAULT_LANG = 'en-GB';

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

var CHANGE_EVENT = 'change',
  ERROR_EVENT = 'appError',
  CHANGE_LANG_EVENT = 'changeLang',
  TOGGLE_IN_PROGRESS_STATE = 'inProgress',
  TOGGLE_GLOBAL_SPINNER_EVENT = 'toggleSpinner';

var _appState = {
  /** is Modal dialog opened */
  isModalOpen: false,

  /** active popover element*/
  activePopover: null
};

var _appError = null;

let appSpinnerShown = false;

let inProgressMeta = { disabled: false, id: ''};

var _appLanguages = [
  {
    key: "gb",
    alt: "United Kingdom",
    title: "English (UK)",
    code: 'en-GB'
  }
];

var _currentLanguage = "gb";
var _isModuleReady = false;

var AppStore = assign({}, EventEmitter.prototype, {

  get defaultLanguageCode() {
    return DEFAULT_LANG;
  },

  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  addErrorListener: function (callback) {
    this.on(ERROR_EVENT, callback);
  },

  removeErrorListener: function (callback) {
    this.removeListener(ERROR_EVENT, callback);
  },

  addChangeLangListener: function (callback) {
    this.on(CHANGE_LANG_EVENT, callback);
  },

  removeChangeLangListener: function (callback) {
    this.removeListener(CHANGE_LANG_EVENT, callback);
  },

  addSpinnerListener(callback) {
    this.on(TOGGLE_GLOBAL_SPINNER_EVENT, callback);
  },

  removeSpinnerListener(callback) {
    this.removeListener(TOGGLE_GLOBAL_SPINNER_EVENT, callback);
  },

  addInProgressListener(callback) {
    this.on(TOGGLE_IN_PROGRESS_STATE, callback);
  },

  removeInProgressListener(callback) {
    this.removeListener(TOGGLE_IN_PROGRESS_STATE, callback);
  },

  emitSpinner() {
    this.emit(TOGGLE_GLOBAL_SPINNER_EVENT, appSpinnerShown);
  },

  emitInProgress(){
    this.emit(TOGGLE_IN_PROGRESS_STATE, inProgressMeta);
  },

  emitError: function () {
    this.emit(ERROR_EVENT);
  },

  emitChange: function () {
    this.emit(CHANGE_EVENT);
  },

  emitLangChange(){
    this.emit(CHANGE_LANG_EVENT);
  },

  //<editor-fold desc="[lang]">
  /** Get list of all available languages*/
  getAvailableLanguages(){
    return _appLanguages;
  },
  /** get current lang key*/
  getCurrentLanguageKey(){
    return _currentLanguage;
  },
  /** find lang by key*/
  getLanguageByKey(langKey){
    return _appLanguages.find((item) => (item.key == langKey));
  },
  /** get active lang*/
  getCurrentLanguage(){
    var langKey = this.getCurrentLanguageKey();
    return this.getLanguageByKey(langKey);
  },
  /** get current lang code*/
  getCurrentLanguageCode(){
    var currentLang = this.getCurrentLanguage();
    return currentLang ? currentLang.code : null;
  },

  getLanguageByCode(code){
    return _appLanguages.find((item) => (item.code == code));
  },

  getAcceptLanguageHeader(){
    var lang = this.getCurrentLanguage();
    return lang.code;
  },

  setLanguage(lang){
    _currentLanguage = lang.key;
    i18n.changeLanguage(lang.code);
    moment.locale(lang.code);
  },
  //</editor-fold desc="[lang]">

  getCurrentPopover: function () {
    return _appState.activePopover;
  },

  getAppError(){
    return _appError;
  },

  setAppError(error){
    _appError = error;
  },

  cleanAppErrorState(){
    _appError = null;
  },

  isModuleReady() {
    return _isModuleReady;
  }
});

Dispatcher.register(function (action) {
  var langCode, lang, currentLang;

  switch (action.actionType) {
    case ActionType.APP_ERROR :
      _appError = action.error;
      AppStore.emitError();
      break;

    case ActionType.AUTH_LOGIN:
      langCode = action.token ? (action.token.Language || DEFAULT_LANG) : DEFAULT_LANG;
      lang = AppStore.getLanguageByCode(langCode);
      if (lang) {
        AppStore.setLanguage(lang);
        AppStore.emitLangChange();
      }
      AppStore.cleanAppErrorState();
      break;

    case ActionType.AUTH_LOGOUT :
    case ActionType.AUTH_LOGIN_FAILURE:
    case ActionType.AUTH_LOGIN_SSO_FAILURE:
      AppStore.cleanAppErrorState();
      break;

    case ActionType.APP_CHANGE_LANG:
      langCode = action.code;
      lang = AppStore.getLanguageByCode(langCode);
      if (!lang) break;
      AppStore.setLanguage(lang);
      AppStore.emitLangChange();
      break;

    case ActionType.APP_LOAD_LANGUAGES:
      _appLanguages = action.languages;
      break;
    case ActionType.APP_PROFILE_SETTING_LOADED:
      const sessionLang = languageService.getCurrentLanguageFromSessionStorage(action.account);
      currentLang = AppStore.getLanguageByCode(sessionLang || action.account.language);
      if (currentLang) {
        AppStore.setLanguage(currentLang);
      }
      AppStore.emitLangChange();
      break;
    case ActionType.APP_MODULE_STATE:
      _isModuleReady = action.state;
      AppStore.emitChange();
      break;

    case ActionType.APP_TOGGLE_GLOBAL_SPINNER:
      appSpinnerShown = action.state;
      AppStore.emitSpinner();
      break;

    case ActionType.APP_TOGGLE_IN_PROGRESS_STATE:
      inProgressMeta = action.state;
      AppStore.emitInProgress();
      break
  }

});


module.exports = AppStore;
